import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaUsers, 
  FaShoppingCart, 
  FaBox, 
  FaTags, 
  FaStar, 
  FaImage, 
  FaGlobe, 
  FaUserTie,
  FaHome,
  FaSignOutAlt,
  FaCog,
  FaTimes,
  FaTicketAlt,
  FaUniversity,
  FaChartBar,
  FaComments,
  FaVideo,
  FaBullhorn,
  FaShareAlt,
  FaCommentDots
} from 'react-icons/fa';
import { logout, updateSupportTicketReadStatusAPI } from '../../utils/api';
import './Sidebar.css';
import { APP_LOGO_URL } from '../../utils/configConstants';
import { useSelector } from 'react-redux';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { newTicketOrReply } = useSelector((state) => state.supportTicketState);

  const menuItems = [
    { path: '/dashboard', name: 'Dashboard', icon: FaHome },
    { path: '/salesperson', name: 'Sales Person', icon: FaUserTie },
    { path: '/wholesaleuser', name: 'Wholesale User', icon: FaUsers },
    { path: '/retailusers', name: 'Retail User', icon: FaUsers },
    { path: '/order', name: 'Order', icon: FaShoppingCart },
    { path: '/categories', name: 'Category', icon: FaTags },
    { path: '/product', name: 'Product', icon: FaBox },
    { path: '/brand', name: 'Brand', icon: FaStar },
    { path: '/banner', name: 'Banner', icon: FaImage },
    { path: '/videos', name: 'Videos', icon: FaVideo },
    { path: '/social-media', name: 'Social Media', icon: FaShareAlt },
    { path: '/testimonials', name: 'Testimonial', icon: FaCommentDots },
    { path: '/broadcast-notification', name: 'Broadcast Notification', icon: FaBullhorn },
    { path: '/country', name: 'Country', icon: FaGlobe },
    // { path: '/state', name: 'State', icon: FaGlobe },
    // { path: '/city', name: 'City', icon: FaGlobe },
    // { path: '/pincode', name: 'Pincode', icon: FaGlobe },
    { path: '/supportticket', name: 'Support Ticket', icon: FaTicketAlt },
    { path: '/generalsetting', name: 'General Setting', icon: FaCog },
    { path: '/bankdetails', name: 'Bank Details', icon: FaUniversity },
    {
      name: "Report",
      path: "/report",
      icon: FaChartBar
    },
    {
      name: "Chat",
      path: "/chat",
      icon: FaComments
    },
    { path: '/promo-text', name: 'Promo Text', icon: FaBullhorn },
    { path: '/announcement-marquee', name: 'Announcement Marquee', icon: FaBullhorn },
  ];

  const handleLogout = () => {
    logout();
  };

  const handleNavigation = async (path, itemName) => {
    if (itemName?.toLowerCase() === 'support ticket') {
      try {
        await updateSupportTicketReadStatusAPI();
      } catch (error) {
        console.log('Error updating support ticket read status:', error);
      }
    }
    navigate(path);
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onClose}></div>
      )}
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img 
              src={APP_LOGO_URL}
              alt="Yug Mantra"
              className="logo-image" 
            />
          </div>
          <button
            type="button"
            className="sidebar-close"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            <FaTimes />
          </button>
        </div>
        
        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <li key={item.path} className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${isActive ? 'active' : ''}`}
                    onClick={() => handleNavigation(item.path, item.name)}
                  >
                    <IconComponent className="nav-icon" />
                    <span className="nav-text">
                      {item.name}
                      {item.name === 'Support Ticket' && newTicketOrReply > 0 && (
                        <span className="ticket-dot" />
                      )}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
        
        <div className="sidebar-footer">
          <button
            type="button"
            className="logout-btn"
            onClick={handleLogout}
          >
            <FaSignOutAlt className="logout-icon" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar; 